import axios from "./axiosConfig";

const gameScoreService = {
  getLeaderboard(game) {
    return axios.get(`/game/${game}/leaderboard`);
  },
  submitScore(game, score) {
    return axios.post(`/game/${game}/score`, { score });
  },
  getActive() {
    return axios.get("/game/active");
  },
  setActive(game) {
    return axios.put("/game/active", { game });
  },
};

export default gameScoreService;
